import type { ReactNode } from 'react';

export const symbol_game_stick_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M721-437.08q99-52.08 99-126T721-689q-99-52-241-52t-241 52.08q-99 52.08-99 126T239-437q99 52 241 52t241-52.08ZM674-356v136q0 24.75-17.62 42.37Q638.75-160 614-160H345q-24.75 0-42.37-17.63Q285-195.25 285-220v-136q-92-31-148.5-85.51Q80-496.02 80-562.8 80-662 196.5-731 313-800 480-800t283.5 69.25Q880-661.51 880-563q0 67.24-56.5 122.12Q767-386 674-356ZM480-563Zm-18 73v-160q0-6-4.5-10.5T447-665q-6 0-10.5 4.5T432-650v175q0 6 4.5 10.5T447-460h87q6.22 0 10.11-4.5Q548-469 548-475t-4.5-10.5Q539-490 533-490h-71Z"
		/>
	</svg>
);
